
import {Routes, Route, Link, useParams} from "react-router-dom";

import Listing from "./Listing";
import Create from "./Create";
import Edit from "./Edit";
import Icon from "../../components/icon";
import Header from "../../layouts/Header";

const SmsManager = () => {
    const {id} = useParams()

    return (
        <>
            <Header
                icon="sms"
                title="Sms Manager"
                buttons={[
                    !id && window.location.pathname !== '/sms/new' &&
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>,
                ]}
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path="new" element={<Create/>}/>
                <Route path=":id" element={<Edit id={id}/>}/>
            </Routes>
        </>
    )
}

export default SmsManager